import { Dispatch } from 'redux'
import { InfoStoreService } from './service'
import { FETCH_INFO_REQUEST, FETCH_INFO_SUCCESS, FETCH_INFO_FAILURE } from './types'

const requested = () => {
  return {
    type: FETCH_INFO_REQUEST,
  }
}

const loaded = (newData: any) => {
  return {
    type: FETCH_INFO_SUCCESS,
    payload: newData,
  }
}

const error = (errorData: any) => {
  return {
    type: FETCH_INFO_FAILURE,
    payload: errorData,
  }
}

export const InfoAction =
  ({ onSuccess = (data?: any) => {}, onError = () => {} }) =>
  (dispatch: Dispatch) => {
    dispatch(requested())
    InfoStoreService()
      .then((data) => {
        dispatch(loaded(data.data))
        onSuccess(data.data)
      })
      .catch((err) => {
        dispatch(error(err))
        onError()
      })
  }
